enum Gender {
    Male = '0',
    Female = '1',
    Other = '2',
}

export default Gender;
